{
  "NAME": "CodeAddModify",
  "GeneralTitle": "Algemeen",
  "ScopeAssignmentTitleTitle": "Reikwijdte Opdracht",
  "AddUserTitle": "Code toevoegen",
  "ModifyCodeTitle": "Code wijzigen",
  "GUID": "IDENTIFIER (GUID):",
  "GUIDPlaceholder": "[Auto Gegenereerd]",
  "Code": "Code:",
  "CodeType": "Type code:",
  "CodeTypeHelp": "Bepaalt welk type de nieuwe code wordt",
  "CodeTypeOptionOne": "Account\/Authorisatie",
  "CodeTypeOptionTwo": "ACD niet beschikbaar",
  "CodeTypePlaceholder": "Account\/Authorisatie",
  "Description": "Beschrijving:",
  "UpdateExisting": "Dubbele items bijwerken:",
  "TelServer": "Telefonie server",
  "Partition": "Verdeling",
  "CodeAddModify_AccountAuthorisation": "Account\/Authorisatie",
  "CodeAddModify_ACDNotAvailable": "ACD niet beschikbaar",
  "CodeAddModify_ErrorMessage_Server_Error": "Serverfout",
  "CodeAddModify_ErrorMessage_Successful": "Succes",
  "CodeAddModify_ServerErrorTitle": "Validatiefouten",
  "CodeAddModify_ValidationWarning": "Zorg ervoor dat alle velden correct zijn ingevuld",
  "CodeAddModify_ButtonHelpLabel": "Helpen?",
  "CodeAddModify_ButtonSubmitLabel": "Sla",
  "CodeAddModify_ButtonCancelLabel": "Annuleren",
  "CodeAddModify_PromptMessage": "Weet je zeker dat je dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren bij het sluiten.",
  "CodeAddModify_PromptConfirm": "Ja",
  "CodeAddModify_PromptCancel": "Annuleren",
  "CodeAddModify_DetailsTitle": "Details gebruiker",
  "CodeAddModify_ValidationError": "Validatiefout",
  "Errors_Code_Required": "Dit veld is verplicht",
  "Errors_Code_Validation": "Geldig formaat vereist: 1, 3-5",
  "Errors_CodeAddModify_Code_Length": "De codenaam moet uit minder dan 100 tekens bestaan",
  "Errors_CodeAddModify_Description_Length": "De beschrijving moet minder dan 100 tekens bevatten"
}